import { render, staticRenderFns } from "./BaseNavigationTabs.vue?vue&type=template&id=05269cc0&lang=pug"
import script from "./BaseNavigationTabs.vue?vue&type=script&lang=js"
export * from "./BaseNavigationTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports